const getAccountSlug = () =>
  window.location.pathname.match(/(pimwacorp)/g)?.[0];

export default getAccountSlug;
